import qs from 'qs';

/**
 * Function to update searchRef from URL query strings.
 */
export const updateSearchRefFromUrl = (searchRef = null) => {
  searchRef && (searchRef.current = qs.parse(window.location.search.slice(1)));
};
